module.exports = __webpack_public_path__ + "img/cobra.d9205a48.png";